(function () {
    'use strict';

    angular
        .module('app')
        .controller('FileSelectorDialogCtrl', FileSelectorDialogCtrl);

    FileSelectorDialogCtrl.$inject = ['$scope', '$q', '$filter', 'entityId', 'SystemService', 'DialogInstance', 'ItemService'];

    /**
     * @ngdoc control
     * @name FileSelectorDialogCtrl
     *
     * @description
     * A dialog which is used for selecting chillidocs files
     * 
     * @param {number} entityId - The ChilliDocs Files will default to being filtered for the entity id.
     *                            If not specified, no files will be initially displayed.
     */
    function FileSelectorDialogCtrl($scope, $q, $filter, entityId, SystemService, DialogInstance, ItemService) {
        /* jshint validthis:true */
        var vm = this;
        vm.loading = false;
        vm.chilliDocsFilesList = [];
        vm.chilliDocsFilesSearchFields = { FileName: '', CreatedBy: '', CreatedDate: '' };
        vm.close = close;
        vm.ok = ok;

        activate();

        function activate() {
            vm.selectedEntity = entityId;
            vm.searchDelay = SystemService.getSearchDelay();

            getChilliDocsFileList();

            $scope.$watch('vm.selectedEntity', function (newVal, oldVal) {
                if (newVal !== oldVal) {
                    getChilliDocsFileList();
                }
            });

            function searchCriteriaWatch(newVal, oldVal) {
                if (newVal !== oldVal) {
                    filterChilliDocsFilesList();
                }
            }

            $scope.$watch('vm.chilliDocsFilesSearchFields.FileName', searchCriteriaWatch);
            $scope.$watch('vm.chilliDocsFilesSearchFields.CreatedBy', searchCriteriaWatch);
            $scope.$watch('vm.chilliDocsFilesSearchFields.CreatedDate', searchCriteriaWatch);
        }

        function getChilliDocsFileList() {
            var promise = null;
            vm.loading = true;
            var fileList = [];

            if (_.isNil(vm.selectedEntity)) {
                promise = $q.when([])
                    .then(getItemsOk, getItemsError);
            } else {
                var searchFields = { file: true, entityIds: vm.selectedEntity };

                promise = ItemService.getItemsByParent(vm.selectedEntity, { recordType: 'File' })
                    .then(getItemsOk, getItemsError);
            }

            getChilliDocsFileList.currentPromise = promise;

            return promise;

            function getItemsOk(data) {
                if (promise === getChilliDocsFileList.currentPromise) {
                    angular.forEach(data.Items, function (item) {
                        fileList.push({
                            FileName: item.Description,
                            FileSize: item.FileSize,
                            FileId: item.Id,
                            CreatedBy: { PreviewNameText: item.CreatedByUserName },
                            CreatedDate: $filter('date')(item.CreatedDate, "dd/MM/yyyy")
                        });
                    });

                    vm.chilliDocsFilesList = angular.copy(fileList);
                    filterChilliDocsFilesList();
                    vm.error = null;
                    vm.loading = false;
                }
            }

            function getItemsError(response) {
                if (promise === getChilliDocsFileList.currentPromise) {
                    vm.chilliDocsFilesList = [];
                    vm.loading = false;
                    vm.error = 'Error fetching file data.';
                }
            }
        }

        function filterChilliDocsFilesList() {
            if (angular.isDefined(vm.chilliDocsFilesList)) {
                angular.forEach(vm.chilliDocsFilesList, function(n) {
                    n.Display = true;
                });
                
                if (angular.isDefined(vm.chilliDocsFilesSearchFields)) {
                    if (angular.isDefined(vm.chilliDocsFilesSearchFields.FileName) && vm.chilliDocsFilesSearchFields.FileName !== null && vm.chilliDocsFilesSearchFields.FileName !== '') {
                        angular.forEach(vm.chilliDocsFilesList, function (n) {
                            if (!n.FileName.toLowerCase().includes(vm.chilliDocsFilesSearchFields.FileName.toLowerCase())) {
                                n.Display = false;
                            }
                        });
                    }

                    if (angular.isDefined(vm.chilliDocsFilesSearchFields.Description) && vm.chilliDocsFilesSearchFields.Description !== null && vm.chilliDocsFilesSearchFields.Description !== '') {
                        angular.forEach(vm.chilliDocsFilesList, function (n) {
                            if (!n.Description.toLowerCase().includes(vm.chilliDocsFilesSearchFields.Description.toLowerCase())) {
                                n.Display = false;
                            }
                        });
                    }
    
                    if (!_.isNil(vm.chilliDocsFilesSearchFields.CreatedBy) && vm.chilliDocsFilesSearchFields.CreatedBy !== '') {
                        angular.forEach(vm.chilliDocsFilesList, function (n) {
                            if (_.isNil(n.CreatedBy.PreviewNameText) || !n.CreatedBy.PreviewNameText.toLowerCase().includes(vm.chilliDocsFilesSearchFields.CreatedBy.toLowerCase())) {
                                n.Display = false;
                            }
                        });
                    }
    
                    if (angular.isDefined(vm.chilliDocsFilesSearchFields.CreatedDate) && vm.chilliDocsFilesSearchFields.CreatedDate !== null && vm.chilliDocsFilesSearchFields.CreatedDate !== '') {
                        angular.forEach(vm.chilliDocsFilesList, function (n) {
                            if (!n.CreatedDate.toLowerCase().includes(vm.chilliDocsFilesSearchFields.CreatedDate.toLowerCase())) {
                                n.Display = false;
                            }
                        });
                    }

                    if (angular.isDefined(vm.chilliDocsFilesSearchFields.Entity) && vm.chilliDocsFilesSearchFields.Entity !== null && vm.chilliDocsFilesSearchFields.Entity !== '') {
                        angular.forEach(vm.chilliDocsFilesList, function (n) {
                            if ((angular.isUndefined(n.Entity) || n.Entity === null || !n.Entity.toLowerCase().includes(vm.chilliDocsFilesSearchFields.Entity.toLowerCase()))) {
                                n.Display = false;
                            }
                        });
                    }
                }
            }
        }

        function ok() {
            var selectedFiles = _.filter(vm.chilliDocsFilesList, function (n) {
                return n.Selected === true;
            });

            var filesArray = [];

            if (angular.isDefined(selectedFiles) && selectedFiles.length > 0) {
                angular.forEach(selectedFiles, function (file) {
                    filesArray.push({
                        File: {
                            FileId: file.FileId,
                            name: file.FileName,
                            size: file.FileSize
                        },
                        FileName: file.FileName,
                        FileSize: file.FileSize
                    });
                });
            }

            DialogInstance.ok(filesArray);
        }

        function close() {
            DialogInstance.cancel();
        }
    }
})();
